export function getEnv(): 'prod' | 'staging' | 'preprod' | 'dev' | 'local' {
  const hostname = window.location.hostname;
  const port = window.location.port;

  switch (hostname) {
    case import.meta.env.VITE_PROD_HOST:
      return 'prod';
    case import.meta.env.VITE_PREPROD_HOST:
      return 'preprod';
    case import.meta.env.VITE_STAGING_HOST:
    case import.meta.env.VITE_STAGING_V2_HOST:
      return 'staging';
    case import.meta.env.VITE_DEV_HOST:
      return 'dev';
    default:
      return port === '3000' ? 'local' : 'dev';
  }
}
